var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "MaintainDeliveryNote2-TabelHeaderForEdit",
      staticClass: "MaintainDeliveryNote2-TabelHeaderForEdit"
    },
    [
      _c(
        "el-form",
        {
          ref: "formData",
          staticClass: "formData",
          attrs: { inline: true, model: _vm.formData, "label-width": "90px" }
        },
        [
          _c("el-form-item", { attrs: { label: "送货单号" } }, [
            _c("span", { staticClass: "showItemName" }, [
              _vm._v(_vm._s(_vm.formData.DELIVERY_NO))
            ])
          ]),
          _c("el-form-item", { attrs: { label: "供应商" } }, [
            _c("span", { staticClass: "showItemName" }, [
              _vm._v(_vm._s(_vm.formData.VENDOR))
            ])
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "出货日期" } },
            [
              _vm.mode === "show"
                ? _c("span", { staticClass: "showItemName" }, [
                    _vm._v(_vm._s(_vm.formData.DELIVERY_DATE))
                  ])
                : _vm._e(),
              _vm.mode === "edit"
                ? _c("el-date-picker", {
                    attrs: { type: "date", placeholder: "选择日期" },
                    on: { change: _vm.handleDay },
                    model: {
                      value: _vm.formData.DELIVERY_DATE,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "DELIVERY_DATE", $$v)
                      },
                      expression: "formData.DELIVERY_DATE"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "到货日期" } },
            [
              _vm.mode === "show"
                ? _c("span", { staticClass: "showItemName" }, [
                    _vm._v(_vm._s(_vm.formData.ARRIVAL_DATE))
                  ])
                : _vm._e(),
              _vm.mode === "edit"
                ? _c("el-date-picker", {
                    attrs: { type: "date", placeholder: "选择日期" },
                    on: { change: _vm.handleARRIVAL_DATE },
                    model: {
                      value: _vm.formData.ARRIVAL_DATE,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "ARRIVAL_DATE", $$v)
                      },
                      expression: "formData.ARRIVAL_DATE"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _vm.formData.STATUS_Caption !== null
                ? [
                    _vm.formData.STATUS_Caption === "未处理"
                      ? _c("span", { staticClass: "showItemName" }, [
                          _vm._v(_vm._s(_vm.formData.STATUS_Caption))
                        ])
                      : _c("span", { staticClass: "showItemName" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/image/" +
                                _vm.formData.STATUS_Caption +
                                ".png"),
                              alt: ""
                            }
                          })
                        ])
                  ]
                : _vm._e()
            ],
            2
          ),
          _c("el-form-item", { attrs: { label: "制单人" } }, [
            _c("span", { staticClass: "showItemName" }, [
              _vm._v(_vm._s(_vm.formData.CREATORID))
            ])
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _vm.mode === "show"
                ? _c("span", { staticClass: "showItemName" }, [
                    _vm._v(_vm._s(_vm.formData.DESCRIPTION))
                  ])
                : _vm._e(),
              _vm.mode === "edit"
                ? _c("el-input", {
                    model: {
                      value: _vm.formData.DESCRIPTION,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "DESCRIPTION", $$v)
                      },
                      expression: "formData.DESCRIPTION"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }